<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card class="rounded-lg pt-4">
      <v-card-title class="headline pa-4 justify-center">
        {{ title }}
      </v-card-title>
      <v-divider />
      <v-card-text
        class="pa-4 body-1 d-flex flex-column justify-center align-center "
        style="font-size: 18px;"
      >
        <p class="text-center" style="max-width: 350px;">
          {{ description }}
        </p>
        <v-list v-if="list">
          <v-list-item v-for="(item, index) in list" :key="index">
            <v-icon style="font-size: 12px;" class="mr-2"
              >fiber_manual_record</v-icon
            >{{ item }}
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="#2661FF"
          outlined
          min-width="100px"
          @click="dialog = false"
        >
          {{ closeText }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "BaseInfoDialog",
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    list: {
      type: Array,
      required: false,
      default: () => []
    },
    closeText: {
      type: String,
      required: true
    }
  },
  data: () => ({ dialog: true }),
  created() {
    console.log({ list: this.list });
  }
};
</script>
